import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";
import { useNavigate } from "react-router-dom";
import {
  PlusCircle,
  Target,
  ChartColumn,
  FileText,
  FilePlus,
} from "lucide-react";
import { observer } from "mobx-react-lite";
import { PATHS } from "@/lib/router";

const ESGReportsHeader = observer(() => {
  const { t } = useTran();
  const navigate = useNavigate();

  const handleAddCustomReport = () => {
    navigate("/esg/report/CUSTOM/1");
  };

  return (
    <PageHeader
      title={t("ESG Reports")}
      icon={FileText}
      description={t("Manage and track your ESG reporting journey")}
      actions={
        <div className="flex flex-wrap items-center gap-2">
          <Button variant="outline" onClick={() => navigate(PATHS.ESG_TARGETS)}>
            <Target />
            {t("Target Settings")}
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(PATHS.ESG_DASHBOARD)}
          >
            <ChartColumn />
            {t("Dashboard")}
          </Button>
          <Button variant="outline" onClick={handleAddCustomReport}>
            <FilePlus />
            {t("Add Custom Report")}
          </Button>
          <Button onClick={() => navigate(PATHS.ESG_FRAMEWORKS)}>
            <PlusCircle />
            {t("Add New Report")}
          </Button>
        </div>
      }
    />
  );
});

export default ESGReportsHeader;
